import * as React from 'react';
import styled from 'styled-components';
import { Colors } from '@origin-digital/style-guide';
import { Box } from '@origin-digital/layout';

interface PasswordStrengthIndicatorRuleProps {
  isValid: boolean;
  displayText: string;
}

const PasswordStrengthIndicatorRule: React.FC<PasswordStrengthIndicatorRuleProps> = ({
  displayText,
  isValid,
}) => (
  <Box marginBottom={1}>
    <Bullet data-id="bullet" isValid={isValid}>
      •
    </Bullet>
    <ConditionText data-id="conditionText" isValid={isValid}>
      {displayText}
    </ConditionText>
  </Box>
);

export { PasswordStrengthIndicatorRule };

interface ListItemProps {
  isValid: boolean;
  'data-id': string;
}

const Bullet = styled.span<ListItemProps>`
  color: ${(props) => (props.isValid ? Colors.GREY16 : Colors.BLUE)};
  vertical-align: middle;
  font-size: 16px;
  display: inline-block;
  width: 1em;
  text-align: center;
  margin-right: 3px;
`;

const ConditionText = styled.span<ListItemProps>`
  font-size: 12px;
  font-weight: 400;
  vertical-align: middle;
  color: ${(props) => (props.isValid ? Colors.GREY16 : Colors.GREY)};
`;
